import { Currency } from 'entities/dictionaries';

export const displayOrderCurrency = (price?: number, currency?: Currency | null): string =>
  currency && (currency?.code === 'USD' || currency?.code === 'GBP')
    ? `${currency?.sign || ''}${price}`
    : `${price}${currency?.sign || ''}`;
